import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { DepartmentEntity } from '../../entities/department.entity';
import { getLatestUpdatedAt } from '../../helper/reducer.helper';
import { DepartmentActions } from '../actions/department.actions';

export const DEPARTMENT_FEATURE_KEY = 'department';

export interface DepartmentState extends EntityState<DepartmentEntity> {
    fetched: boolean;
    latestUpdatedAt: Date | null;
}

const adapter = createEntityAdapter<DepartmentEntity>({
    selectId: (Entity) => Entity.Id,
});

const initialState: DepartmentState = adapter.getInitialState({
    fetched: false,
    latestUpdatedAt: null,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export const departmentReducer = createReducer(
    initialState,
    on(DepartmentActions.loadSuccess, (state, { Payload }) =>
        adapter.setMany(Payload, {
            ...state,
            latestUpdatedAt: getLatestUpdatedAt(Payload, state.latestUpdatedAt),
            fetched: true,
        }),
    ),
    on(DepartmentActions.changeSuccess, (state, { Payload }) => adapter.setOne(Payload, state)),
    on(DepartmentActions.addSuccess, (state, { Payload }) => adapter.addOne(Payload, state)),
    on(DepartmentActions.deleteSuccess, (state, { Payload }) => adapter.removeOne(Payload, state)),
);

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllDepartment = selectAll;
export const selectDepartmentEntities = selectEntities;

export const selectDepartmentFetched = (state: DepartmentState) => state.fetched;
export const selectDepartmentLatestUpdatedAt = (state: DepartmentState) => state.latestUpdatedAt;
